import * as React from 'react'
import type { CountryCode } from 'codegen/types'
import { getCookie } from 'utils/dom'
import { COUNTRY_COOKIE_NAME, REGION_COOKIE_NAME } from 'constants/cookies'

export const EUCountries = new Set([
  'AT',
  'BE',
  'BA',
  'BG',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MD',
  'NL',
  'PL',
  'PT',
  'RO',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'TR',
  'UA',
])

export const EUAndUKCountries = new Set([
  // oxlint-disable-next-line unicorn/prefer-spread
  ...Array.from(EUCountries),
  'GB', // United Kingdom
])

// oxlint-disable-next-line unicorn/prefer-spread
export const TIER_ONE_COUNTRIES = new Set([...Array.from(EUCountries), 'AU', 'US', 'CA', 'NZ'])

export const useUserLocation = () => {
  const [cookieCountry, setCookieCountry] = React.useState<CountryCode | undefined>()
  const [cookieRegion, setCookieRegion] = React.useState<string | undefined>()

  React.useEffect(() => {
    const countryCookieValue = getCookie(COUNTRY_COOKIE_NAME)
    if (countryCookieValue.length > 0) {
      setCookieCountry(countryCookieValue as CountryCode)
    }

    const regionCookieValue = getCookie(REGION_COOKIE_NAME)
    if (regionCookieValue.length > 0) {
      setCookieRegion(regionCookieValue)
    }
  }, [])

  const isUserFromTierOne = TIER_ONE_COUNTRIES.has(cookieCountry ?? '')
  const isUserFromEUOrUK = EUAndUKCountries.has(cookieCountry ?? '')

  return {
    country: cookieCountry,
    region: cookieRegion,
    isUserFromTierOne,
    isUserFromEUOrUK,
  }
}
